import { render, staticRenderFns } from "./webexpense_expense.vue?vue&type=template&id=028e3fd4&scoped=true"
import script from "./webexpense_expense.vue?vue&type=script&lang=js"
export * from "./webexpense_expense.vue?vue&type=script&lang=js"
import style0 from "./webexpense_expense.vue?vue&type=style&index=0&id=028e3fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e3fd4",
  null
  
)

export default component.exports